import React, {Component} from 'react';
import './TokenInput.css';
import PropTypes from 'prop-types';


export default class TokenInput extends Component {

    static defaultProps = {
        padding: 40,
        placeholder: "Enter token here",
        maxTokenLength: 6
    };

    static propTypes = {
        name: PropTypes.string,
        placeholder: PropTypes.string,
        disabled:  PropTypes.bool,
        padding: PropTypes.number,
        className: PropTypes.string,
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        maxTokenLength: PropTypes.number
    };

    constructor(props){
        super(props);

        this.state = {
            focus: false,
            placeholder: props.placeholder,
            token: ''
        };

        //  bind
        this.onChange = this.onChange.bind(this);
    }

    onChange(evt){

        const value = evt.target.value;
        this.setState({
            token: value
        });

        if(this.props.onChange){
            this.props.onChange({ value , isValid: value.length >= this.props.maxTokenLength },evt);
        }

    }

    getToken(){
        return this.state.token;
    }

    render(){

        const  { isBusy , padding , className  , name } = this.props;
        return <div style={{ padding }} >
            <input className={`token-input ${className}`} autoComplete={"off"} type="text" disabled={isBusy}
                   style={{
                       color: (this.state.focus || (!this.state.focus && this.state.token)) ? "black" : "transparent",
                       letterSpacing: (!this.state.placeholder || this.state.token) && 10
                   }}
                   placeholder={this.state.placeholder}
                   maxLength={this.props.maxTokenLength}
                   onFocus={() => this.setState({
                       placeholder: this.state.token ? this.state.placeholder : "",
                       focus: true
                   })}
                   onBlur={(evt) => {

                       this.setState({
                           placeholder: this.props.placeholder,
                           focus: false
                       });

                       if(this.props.onBlur)
                           this.props.onBlur(evt);

                   }}
                   value={this.state.token}
                   name={name}
                   id={name}
                   onChange={this.onChange}/>
        </div>
    }

}


// WEBPACK FOOTER //
// ./src/components/TokenInput/TokenInput.js